import Switcher from '@/components/Switcher/Switcher.vue'
import VueClipboard from 'vue-clipboard2'
import Hint from "@/components/Hint/Hint.vue"
import {mapGetters} from "vuex";
import DeleteGateModal from "@/components/__new_ui_kit/Modals/DeleteGateModal/DeleteGateModal";
import {defaultComponentProps, defaultModalEvents, defaultModalProps} from "@/components/__new_ui_kit/Modal/defaults";

export default {
    props: ["item", "updateList"],
    name: 'CustomTrComponent',
    components: {Switcher, VueClipboard, Hint},
    data() {
        return {
            id: this.$props.item.id,
            avatar: require(`../../assets/avatar.svg`),
            flag: false,
            thingToCopy: `A string that's not all that long or important. Sorry to disappoint.`,
            tooltipCopy: '',
            tooltipCopyBase: {
                for_copy: 'Click to copy to clipboard',
                copied: "Copied to clipboard",
            },
            tooltipTexts: {
                url: 'Copy to clipboard',
                custom_url: 'Copy to clipboard'
            }
        }
    },
    methods: {
        updateContent(id, propTabAnalytics) {
            //this.$router.push({ path:`/my-gates/${id}`})
            //*****
            let name = 'Settings Page';
            if (propTabAnalytics === true) {
                name = 'Analytics Page';
            }
            this.$router.push({
                name: name,
                params: {
                    id: `${id}`,
                    propTabAnalytics: `${propTabAnalytics}`
                }
            })
        },
        openDeleteModal(deleteId) {
            this.$modal.show(DeleteGateModal,
              {...defaultComponentProps, 'deleteId': deleteId, updateList: this.$props.updateList},
              {...defaultModalProps(), name: 'delete-gate-modal'},
              {...defaultModalEvents(() => console.log('check cancel cb'))})
        },
        changeActive(data) {
            this.$store.dispatch('changeContentActive', {
                    id: data.id,
                    active: data.status
                }
            )
        },
        switcherFlag(flag) {
            this.flag = flag
        },
        link(id) {
            return process.env.VUE_APP_URL + `/${id}`
        },
        arch(id) {
            return `arch-${id}`
        },
        shortName(longName) {
            return longName && (longName.slice(0,20).length < longName.length) ? longName.slice(0,20) + '...' : longName
        },
        changeTooltipText(link) {
            if (link === 'url') {
                this.tooltipTexts.url = 'Copied!'
                this.tooltipTexts.custom_url = 'Copy to clipboard!'
            }
            if (link === 'custom_url') {
                this.tooltipTexts.url = 'Copy to clipboard!'
                this.tooltipTexts.custom_url = 'Copied!'
            }
            // let currentNode = evt.currentTarget;
            // let parent = currentNode.closest('.tooltip-block');
            // let tooltip = parent.getElementsByClassName('tooltip');
            // tooltip[0].innerText = this.tooltipCopyBase.copied;
        },
        bannedContent() {
            return false;
        }
    },
    created() {
        this.tooltipCopy = this.tooltipCopyBase.for_copy;
    }
}
